import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services';
import { environment } from 'src/environments/environment';
import { ROUTER_PATHS } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  canMatch(): boolean {
    const isLoggedIn = this.authService.isLoggedIn;

    if (isLoggedIn) {
      return true;
    }

    const { root, login } = ROUTER_PATHS.auth;
    if (!environment.enableLaunchPage) {
      this.router.navigate([root, login]);
      return false;
    }
    this.router.navigate([ROUTER_PATHS.launchPage]);

    return false;
  }
}
